import IconButton from 'LuxKit/Button/IconButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ModalContext from 'contexts/ModalContext'
import type { ComponentProps } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import HeaderContactOptionsModal from './HeaderContactOptionsModal'

type InheritedIconButtonProps = Pick<ComponentProps<typeof IconButton>, 'size' | 'className'>

interface Props extends InheritedIconButtonProps {
}

function HeaderContactOptionsMenu(props: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const openModal = useCallback(() => {
    showModal(<HeaderContactOptionsModal />)
  }, [showModal])

  return <IconButton
    {...props}
    kind="tertiary"
    onClick={openModal}
    variant="dark"
    aria-label={intl.formatMessage(
      {
        id: '3uLBLiJ0Ff',
        defaultMessage: 'Need Help? Call our Travel Experts',
        description: 'Contact options menu button aria label',
      },
    )}
    rel="nofollow"
  >
    <LinePhoneIcon />
  </IconButton>
}

export default HeaderContactOptionsMenu
